import { useCallback, useEffect } from 'react';
import { useKeyPress } from '../../../Shared/UseKeyPress';
import { fabric } from 'fabric';
import { initialZoomLevel } from '../Helpers';

const useCanvasOutsideEvents = (
  canvasEl: fabric.Canvas | null,
  pointArray: fabric.Circle[],
  lineArray: fabric.Line[],
  activeLine: fabric.Line | undefined | null,
  activeShape: fabric.Polygon | null | undefined,
  polygonMode: boolean,
  rectangleMode: boolean,
  fullScreenMode: boolean,
  clearPolygon: () => void,
  setRect: (rect: fabric.Rect | null) => void
) => {
  useKeyPress('Escape', false, () => {
    escPressed();
  });

  const escPressed = useCallback(() => {
    if (canvasEl && polygonMode && pointArray.length) {
      clearPolygon();
    }
  }, [canvasEl, clearPolygon, pointArray.length, polygonMode]);

  useEffect(() => {
    if (canvasEl && !polygonMode && pointArray.length) {
      clearPolygon();
    }
    if (!rectangleMode) {
      setRect(null);
    }
  }, [polygonMode, rectangleMode, canvasEl, pointArray, lineArray, activeLine, activeShape, clearPolygon, setRect]);

  useEffect(() => {
    if (canvasEl != null) {
      canvasEl.setZoom(initialZoomLevel);
      canvasEl.absolutePan(new fabric.Point(0, 0));
    }
  }, [canvasEl, fullScreenMode]);
};

export default useCanvasOutsideEvents;
